<template>
    <div>
        <breadcrumb :main-name="mainName" :breadcrumbList="breadcrumbList"></breadcrumb>
        <div class="container">
            <a-form :form="form">
                <div class="top">
                    <h5>客户信息</h5>
                    <div class="form-wrap">
                        <a-row :gutter="24">
                            <a-col span="8">
                                <a-form-item label="联系人">
                                    <a-input placeholder="请输入联系人姓名"
                                             v-decorator="['customer.realName', { rules: [{ required: true, message: '请输入联系人姓名！' }] }]"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="账号" :validate-status="errorAccount?'error':'success'"
                                             :help="errorAccount?errAccountMsg:''">
                                    <a-input placeholder="请输入账号"
                                             @blur="checkAccount()"
                                             v-decorator="['customer.sName', { rules: [{ required: true, message: '请输入账号！' }] }]"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="职位">
                                    <a-input placeholder="请输入联系人职位"
                                             v-decorator="['customer.position', { rules: [{ required: true, message: '请输入联系人职位！' }] }]"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="24">
                            <a-col span="8">
                                <a-form-item label="手机号码" :validate-status="errorPhone?'error':'success'"
                                             :help="errorPhone?errPhoneMsg:''">
                                    <a-input placeholder="请输入联系人手机号码" @blur="checkPhone()"
                                             v-decorator="['customer.phone', { rules: [{ required: true, message: '请输入联系人手机号码！' }] }]"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="固定电话">
                                    <a-input placeholder="请输入联系人固定电话" v-decorator="['customer.telephone']"/>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="邮箱" :validate-status="errorEmail?'error':'success'"
                                             :help="errorEmail?'请输入正确的邮箱地址！':''">
                                    <a-input placeholder="请输入联系人邮箱" @blur="checkEmail()"
                                             v-decorator="['customer.email']"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="24">
                            <a-col span="8">
                                <a-form-item label="所在地">
                                    <a-cascader
                                            :displayRender="displayRender"
                                            expandTrigger="hover"
                                            v-decorator="['customer.rName',
          { rules: [{ required: true, message: '请选择联系人所在地！' }] }]"
                                            placeholder="请选择联系人所在地"
                                            :options="citySource"
                                            @change="handleSelectChangeAddress"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="事业部">
                                    <a-input placeholder="请输入联系人所属事业部"
                                             v-decorator="['customer.division']"
                                    />
                                </a-form-item>
                            </a-col>

                        </a-row>
                    </div>
                </div>
                <div class="bottom">
                    <h5>公司信息</h5>
                    <div class="form-wrap">
                        <a-row :gutter="24">
                            <a-col span="8">
                                <a-form-item label="公司名称">
                                    <a-select
                                            showSearch
                                            v-decorator="['company.cName', { rules: [{ required: true, message: '请输入公司名称！' }] }]"
                                            placeholder="请输入公司名称"
                                            :defaultActiveFirstOption="false"
                                            :showArrow="false"
                                            :filterOption="false"
                                            @search="searchCompanyName"
                                            @change="selectCompanyName"
                                    >
                                        <a-select-option v-for="(item,index) in companyList" :key="item.cID"
                                                         :value="item.cName"
                                        >{{item.cName}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="所在城市">
                                    <a-cascader
                                            :displayRender="displayRender"
                                            expandTrigger="hover"
                                            v-decorator="['company.rName',
          { rules: [{ required: true, message: '请选择公司所在城市！' }] }]"
                                            placeholder="请输入公司所在城市"
                                            :options="citySource"
                                            @change="handleSelectChangeCity"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="行业分类">
                                    <a-cascader
                                            :displayRender="displayRender"
                                            expandTrigger="hover"
                                            v-decorator="['company.industryName',
          { rules: [{ required: true, message: '请选择公司行业分类！' }] }]"
                                            placeholder="请输入公司行业分类"
                                            :options="industryList"
                                            @change="handleSelectChangeIndustry"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="24">
                            <a-col span="8">
                                <a-form-item label="公司地址">
                                    <a-input placeholder="请输入公司地址"
                                             v-decorator="['company.cAddress']"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="公司品牌">
                                    <a-select mode="tags"
                                              :tokenSeparators="[',']"
                                              v-decorator="['brandList.bTitle',{ rules: [{ required: true, message: '请输入公司品牌！' }] }]"
                                              @change="handleAddBrand"
                                              @deselect="deleteBrand"
                                              placeholder="请添加公司品牌">
                                        <a-select-option v-for="(item,index) in brandArr" :key="item.bID"
                                                         :value="item.bTitle"
                                        >{{item.bTitle}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="备注">
                                    <a-input placeholder="请输入备注"
                                             v-decorator="['company.cRemark']"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                </div>
                <div class="btns">
                    <a-button type="default" @click="cancleHandle">取消</a-button>
                    <a-button type="primary" v-if="!isEdit" @click="handleSubmit">创建</a-button>
                    <a-button type="primary" v-else @click="handleSubmit">确定</a-button>
                </div>
            </a-form>

        </div>
    </div>
</template>

<script>
    import breadcrumb from '../common/Breadcrumb.vue'
    import api from '../../commomFun/api.js'
    import timeFormat from '../../commomFun/timeFormat';

    export default {
        components: {
            breadcrumb
        },
        data() {
            return {
                // 面包屑
                breadcrumbList: [
                    {
                        name: '客户管理',
                        path: '/clientList'
                    },
                    {
                        name: '新建客户',
                        path: ''
                    }
                ],
                mainName: '新建客户',
                isEdit: false,
                params: {
                    customer: {
                        realName: '',
                        sName: '',
                        phone: '',
                        position: '',
                        rID: '',
                        email: '',
                        telephone: '',
                        division: '',
                    },
                    company: {
                        cID: '',
                        cName: '',
                        cAddress: '',
                        crID: '',
                        iID: '',
                        cRemark: '',
                    },
                    brandList: [
                        {
                            bID: '',
                            bTitle: '',
                            cID: '',
                            industryId: '',
                        }
                    ],
                    deleteBrandList: []
                },
                industryList: [],
                citySource: [],
                brandArr: [],
                companyList: [],
                form: this.$form.createForm(this, {name: 'coordinated'}),
                errorPhone: false,
                errPhoneMsg: '',
                errorEmail: false,
                errorAccount: false,
                errAccountMsg: '',
                editInfo: {},

            }
        },
        mounted() {
            this.isEditFun()
            this.getCityList()
            this.tradeList()
        },
        methods: {
            //是编辑还是新建
            isEditFun() {
                let info = JSON.parse(sessionStorage.getItem('clientData'))
                console.log(info);
                this.isEdit = info.isEdit
                if (info.isEdit) {
                    this.breadcrumbList[1].name = '编辑客户'
                    this.mainName = '编辑客户'
                    this.params.brandList = info.data.brandList
                    this.brandArr = info.data.brandList
                    this.params.customer = info.data.customer
                    this.params.company = info.data.customer
                    this.form.setFieldsValue({
                        customer: {
                            realName: info.data.customer.realName,
                            sName: info.data.customer.sName,
                            phone: info.data.customer.phone,
                            position: info.data.customer.position,
                            rName: [info.data.customer.prID, info.data.customer.rID],
                            email: info.data.customer.email,
                            telephone: info.data.customer.telephone,
                            division: info.data.customer.division,
                        },
                        company: {
                            cName: info.data.customer.cName,
                            cAddress: info.data.customer.cAddress,
                            rName: [info.data.customer.cprID, info.data.customer.crID],
                            industryName: [info.data.customer.piID, info.data.customer.iID],
                            cRemark: info.data.customer.cRemark,
                        },
                        brandList: {
                            bTitle: info.data.customer.bTitle.split(',')
                        }
                    })
                    this.getBrandList(info.data.customer.cID)
                    ;
                } else {
                    this.breadcrumbList[1].name = '新建客户'
                    this.mainName = '新建客户'
                }
            },
            //获取城市列表
            getCityList() {
                api.getApi('/machine/getAreaList').then(res => {
                    if (res.data.code == 200) {
                        let areaList = []
                        for (let firstKey of res.data.data) {
                            let firstObj = {
                                value: firstKey.key,
                                label: firstKey.value,
                                children: []
                            }
                            for (let secondKey of firstKey.children) {
                                let secondObj = {
                                    value: secondKey.key,
                                    label: secondKey.value,
                                    children: []
                                }
                                firstObj.children.push(secondObj)
                            }
                            areaList.push(firstObj)
                        }
                        // console.log('areaList', areaList)
                        this.citySource = areaList
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            // 获取行业类型
            tradeList() {
                let ads = [];
                let resinfo = [];
                api.getApi("/customerManager/getIndustryList")
                    .then(res => {
                        if (res.data.code === 200) {
                            resinfo = res.data.data;
                            for (let data of resinfo) {
                                let obj = {
                                    label: data.industryName,
                                    value: data.industryId,
                                    children: []
                                };
                                for (let item of data.children) {
                                    let itemobj = {
                                        label: item.industryName,
                                        value: item.industryId
                                    };
                                    obj.children.push(itemobj);
                                }
                                ads.push(obj);
                            }
                            this.industryList = ads;
                        } else {
                            this.$message.warning(res.data.msg);

                        }
                    })
                    .catch(err => {
                        console.log(err);

                    });
            },
            //创建
            handleSubmit(e) {
                let that = this
                e.preventDefault();
                this.form.validateFields((err, values) => {
                        if (!err) {
                            console.log('表单数据', values);
                            console.log('需修改数据', this.params);
                            if (!this.checkPhone(values.phone)) {
                                //手机号错误
                                that.errorPhone = true
                                this.errPhoneMsg = '请输入正确的手机号码！'
                            } else {
                                that.errorPhone = false
                                //提交数据
                                let obj = {
                                    customer: {
                                        realName: values.customer.realName,
                                        sName: values.customer.sName,
                                        phone: values.customer.phone || '',
                                        position: values.customer.position || '',
                                        rID: this.params.customer.rID,
                                        email: values.customer.email || '',
                                        telephone: values.customer.telephone || '',
                                        division: values.customer.division || '',
                                    },
                                    company: {
                                        cID: this.params.company.cID,
                                        cName: this.params.company.cName,
                                        cAddress: values.company.cAddress || '',
                                        rID: this.params.company.crID,
                                        iID: this.params.company.iID,
                                        cRemark: values.company.cRemark || ''
                                    },
                                    brandList: this.params.brandList,
                                    deleteBrandList: this.params.deleteBrandList
                                }
                                console.log('提交', obj)
                                if (this.isEdit) {
                                    obj.customer.uID = this.params.customer.uID
                                    api.postApi('/customerManager/update', obj).then(res => {
                                        if (res.data.code == 200) {
                                            this.$message.success('修改成功')
                                            sessionStorage.setItem('clientId', this.params.company.uID);
                                            this.$router.push('/clientDetail')
                                        } else {
                                            this.$message.warning(res.data.msg)
                                        }
                                    })
                                } else {
                                    api.postApi('/customerManager/create', obj).then(res => {
                                        if (res.data.code == 200) {
                                            this.$message.success('创建成功')
                                            sessionStorage.setItem('clientId', res.data.data);
                                            this.$router.push('/clientDetail')
                                        } else {
                                            this.$message.warning(res.data.msg)
                                        }
                                    })
                                }
                            }


                        } else {
                            this.$message.warning('请完善表单必填项！')
                            console.log(!this.form.getFieldsValue(['customer.phone']).customer.phone);
                            if(!this.form.getFieldsValue(['customer.phone']).customer.phone){
                                this.errorPhone = true
                                this.errPhoneMsg = '请输入联系人手机号码！'
                            }
                            if(!this.form.getFieldsValue(['customer.account']).customer.account){
                                this.errorAccount = true
                                this.errAccountMsg = '请输入联系人账号！'
                            }
                        }
                    }
                )
                ;
            },
            //取消按钮
            cancleHandle() {
                this.$router.go(-1)
            }
            ,
            //手机号验证
            checkPhone(value) {
                let re = /^1[3456789]\d{9}$/
                let text = value ? value : this.form.getFieldsValue(['customer.phone']).customer.phone
                // console.log(text);
                if (text) {
                    if (!re.test(text)) {
                        //手机号错误
                        this.errorPhone = true
                        this.errPhoneMsg = '请输入正确的手机号码！'
                        return false
                    } else {
                        this.errorPhone = false
                        return true
                    }
                }
            },
            checkEmail(value) {
                let text = value ? value : this.form.getFieldsValue(['customer.email']).customer.email
                let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if (text) {
                    if (!reg.test(text)) {
                        this.errorEmail = true
                        return false
                    } else {
                        this.errorEmail = false
                        return true
                    }
                }

            },
            //账号查询
            checkAccount() {
                let value = this.form.getFieldsValue(['customer.sName']).customer.sName
                console.log(value);
                api.getApi('/customerManager/checkUsername', {sName: value}).then(res => {
                    if (res.data.code == 200) {
                        if (res.data.data != 0) {
                            this.errorAccount = true
                            this.errAccountMsg = '账号名被占用！'
                        }else{
                            this.errorAccount = false
                        }
                    } else {
                        this.$message.warning('查询账号出错' + res.data.msg)
                    }
                })
            }
            ,
            //联系人所在地
            handleSelectChangeAddress(value, options) {
                console.log(value, options);
                this.params.customer.rID = value[1]
                this.params.customer.rName = options[1].label
            }
            ,
            //查询公司列表
            searchCompanyName(value) {
                // console.log(value);
                let that = this
                if (value) {
                    api.getApi('/customerManager/getCompanyByName', {companyName: value}).then(res => {
                        if (res.data.code == 200) {
                            if(res.data.data.length){
                                that.companyList = that.unique(res.data.data)
                            }else{
                                this.companyList = [{cName: value, cID: ''}];
                            }

                        } else {
                            that.$message.warning(res.data.msg)
                        }
                    })
                }
            }
            ,
            //公司名去重
            unique(arr) {
                const res = new Map();
                return arr.filter((a) => !res.has(a.cName) && res.set(a.cName, 1))
            }
            ,
            //选择公司名
            selectCompanyName(value, options) {
                console.log(value, options);
                this.params.company.cID = options.key
                this.params.company.cName = value
                //获取品牌列表
                this.getBrandList(options.key)
            },
            //根据公司id获取品牌列表
            getBrandList(id) {
                api.getApi('/customerManager/getBrandList', {companyId: id}).then(res => {
                    if (res.data.code == 200) {
                        this.brandArr = res.data.data
                    } else {
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            //公司所在城市
            handleSelectChangeCity(value, options) {
                console.log(value, options);
                this.params.company.crID = value[1]
            }
            ,
            //只显示最后一项
            displayRender({labels}) {
                return labels[labels.length - 1];
            }
            ,
            //行业类型
            handleSelectChangeIndustry(value, options) {
                // console.log(value);
                this.params.company.iID = value[1]
            }
            ,
            //添加品牌
            handleAddBrand(value) {
                let that = this
                this.params.brandList = value.map((item) => {
                    console.log(that.getBID(item));
                    if (this.params.deleteBrandList.indexOf(that.getBID(item)) != -1) {
                        this.params.deleteBrandList.splice(this.params.deleteBrandList.indexOf(that.getBID(item)), 1)
                    }
                    let obj = {
                        bID: that.getBID(item),
                        bTitle: item,
                    }
                    return obj
                })

                console.log(value, this.params.brandList);
            },
            //删除品牌
            deleteBrand(value) {
                // console.log(value, this.getBID(value));
                let bID = this.getBID(value)
                if (bID != '') {
                    this.params.deleteBrandList.push(bID)
                }
                console.log('被删除的品牌', this.params.deleteBrandList);
            },
            //根据bTitle获取bID
            getBID(value) {
                // console.log(value, this.brandArr);
                for(let data of this.brandArr){
                    if(data.bTitle == value){
                        return data.bID
                    }
                }

            },
        }
    }
</script>
<style scoped>
    .container {
        padding: 24px;
    }

    .top, .bottom {
        background: #fff;
    }

    .top h5, .bottom h5 {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        padding-left: 32px;
        line-height: 54px;
        border-bottom: 1px solid #E8E8E8;
    }

    .top {
        margin-bottom: 24px;
    }

    .form-wrap {
        padding: 32px;
    }

    .btns {
        margin-top: 32px;
        text-align: center;
    }

    .btns button:first-child {
        margin-right: 16px;
    }
</style>
<style>
    .form-wrap .ant-form-item-control {
        width: 282px;
    }

    .ant-form-item-label label:before {
        content: '';
    }
    .ant-form-item-label label:after{
        content: '';
    }
    .ant-form-item-label .ant-form-item-required:after {
        margin-right: 4px;
        content: '*';
        font-size: 14px;
        color: #f5222d;
    }
</style>